module.exports = __webpack_public_path__ + "img/knu2_gallery3.d9eb042d.jpg";